import * as React from 'react';

// material-ui
import { CardContent, Typography } from '@mui/material';

import MainCard from 'ui-component/cards/MainCard';

const NotAuthorized = () => {
	return (
		<MainCard title="Not authorized!" content={false}>
			<CardContent>
				<Typography
					variant="subtitle1"
					sx={{ marginBottom: '20px', fontSize: '0.8rem' }}
				>
					Please contact superadmin to give you the right permissions
				</Typography>
			</CardContent>
		</MainCard>
	);
};

export default NotAuthorized;
